import React from "react";
import { useContent } from "@/content/ContentProvider";
import { Hero } from "@/components/site/HomeTop";
import { Method } from "@/components/site/HomeMid";
import {
  AudiencesSection,
  PracticeSection,
  InsightsSection,
  ContactBlock,
} from "@/components/site/HomeBottom";
import {
  Definition,
  Difference,
  ChapterRail,
} from "@/components/site/Positioning";
import Journey from "@/components/site/Journey";
import Manifesto, { ScorecardSlide } from "@/components/site/Manifesto";
import Commitments from "@/components/site/Commitments";
import Morning from "@/components/site/Morning";
import { PriceStrip } from "@/components/site/Prices";
import ScorecardTeaser from "@/components/site/ScorecardTeaser";

export default function Home() {
  const { nextLayout } = useContent();
  // The new home is one story with one first step: the problem, what you end
  // up with, a day with the tool, then the check.
  if (nextLayout)
    return (
      <>
        <ChapterRail />
        <Hero />
        <Manifesto />
        <Commitments />
        <PriceStrip />
        <Morning outro={<ScorecardSlide />} />
      </>
    );
  return (
    <>
      <ChapterRail />
      <Hero />
      <ScorecardTeaser />
      <Definition />
      <Journey />
      <Difference />
      <Method />
      <AudiencesSection />
      <PracticeSection />
      <InsightsSection />
      <ContactBlock />
    </>
  );
}
